import { client } from '../api/generated/client.gen';

export const getFetchAnaloguesExcelAxios = async (
  exportModels: string[],
  allowDraft = false,
) => {
  const params = new URLSearchParams({ AllowDraft: String(allowDraft) });

  for (const modelId of exportModels) {
    params.append('AnalogueModelIds', modelId);
  }
  const response = await client.instance.get(
    '/api/v1/downloads/analogue-models-excel',
    {
      params,
      responseType: 'blob',
    },
  );

  if (response.data) {
    const fileURL = window.URL.createObjectURL(response.data);

    const link = document.createElement('a');
    link.href = fileURL;
    link.download = 'export.xlsx';

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(fileURL);
  }

  return URL.revokeObjectURL(response.data);
};
